import { render, staticRenderFns } from "./RevisionRequestNote.vue?vue&type=template&id=50d2c21f&scoped=true&"
import script from "./RevisionRequestNote.vue?vue&type=script&lang=js&"
export * from "./RevisionRequestNote.vue?vue&type=script&lang=js&"
import style0 from "./RevisionRequestNote.vue?vue&type=style&index=0&id=50d2c21f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d2c21f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
